/// <amd-module name="Analytics/Shared/Visuals/AreaChartView/ControllerViews/AreaChartView" />
import { LoadingComponent } from "Analytics/Shared/Analytics-Visuals-Common/LoadingComponent/LoadingComponent";
import * as React from "react";
import { Chart } from "VSS/Features/Charts/Chart";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { SpinnerSize } from "VSSUI/Spinner";

export interface IAreaChartProps extends IVssComponentProperties {
    errorText?: string;
    chartOptions?: ChartProps | undefined;
    errorTextRenderer?: (errorText?: string) => JSX.Element;
}
export class AreaChartView extends VssComponent<IAreaChartProps, {}> {
    public componentDidMount() {
        window.addEventListener("resize", this.onWindowResize);
    }

    public render(): JSX.Element {
        if (this.props.errorText) {
            return this._renderError();
        }

        if (this.props.chartOptions) {
            return (
                <div className={this.props.className}>
                    <Chart {...this.props.chartOptions} className="flex-column" />
                </div>
            );
        } else {
            return <LoadingComponent className="card-spinner flex-column flex-grow" size={SpinnerSize.large} />;
        }
    }

    private _renderError(): JSX.Element {
        if (this.props.errorTextRenderer) {
            return this.props.errorTextRenderer(this.props.errorText);
        } else {
            return <div>{this.props.errorText}</div>;
        }
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.onWindowResize);
    }

    private onWindowResize = () => this.forceUpdate();
}
